import { useTranslation } from 'react-i18next'
import styles from './UnsupportedFile.module.scss'

const UnsupportedFile = () => {
  const { t } = useTranslation()
  return (
    <div className={styles['unsupported-file']}>
      <p className={styles['unsupported-file__txt']}>{t('uploads.unsupportedFileView')}</p>
    </div>
  )
}

export default UnsupportedFile
